import { useState, useEffect, useCallback } from 'react';
import { cloud } from '../utils/cloudStorage';
import { haptic } from '../utils/haptic';

const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;
const VISIT_COUNT_KEY = 'visit_count';
const PROMPT_DISMISSED_KEY = 'home_prompt_dismissed';
const VISITS_BEFORE_PROMPT = 3;

export function useHomeScreenPrompt() {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    (async () => {
      const dismissed = await cloud.get<boolean>(PROMPT_DISMISSED_KEY);
      if (dismissed) return;

      if (!tg?.addToHomeScreen || !tg?.checkHomeScreenStatus) return;

      tg.checkHomeScreenStatus((status: string) => {
        if (status === 'added') return;
        if (status === 'unsupported') return;
      });

      const count = (await cloud.get<number>(VISIT_COUNT_KEY)) ?? 0;
      const newCount = count + 1;
      await cloud.set(VISIT_COUNT_KEY, newCount);

      if (newCount >= VISITS_BEFORE_PROMPT) {
        setShouldShow(true);
      }
    })();
  }, []);

  const addToHome = useCallback(() => {
    if (!tg?.addToHomeScreen) return;
    haptic.action();
    tg.addToHomeScreen();
    setShouldShow(false);
    void cloud.set(PROMPT_DISMISSED_KEY, true);
  }, []);

  const dismiss = useCallback(() => {
    haptic.tap();
    setShouldShow(false);
    void cloud.set(PROMPT_DISMISSED_KEY, true);
  }, []);

  return { shouldShow, addToHome, dismiss };
}
